export const getSalesChannel = (host: string) => {
  if (host.includes("co.nz") || host.includes("canz")) {
    return "CANZ";
  }
  return "COTD";
};
